// @flow
import { Checkbox } from "@nested/brand";

const defaultCopy =
  "Send me emails about my home, the area and the housing market.";

type Props = {
  className?: string,
  checked: boolean,
  onChange: (boolean) => void,
  labelCopy?: string,
};

export const PrivacyPolicyCheckbox = ({
  className,
  checked,
  labelCopy = defaultCopy,
  onChange,
}: Props) => (
  <div className={className}>
    <Checkbox
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      label={labelCopy}
    />
  </div>
);
